import { Tag, Tooltip } from '@all-manager/design-system-v2';
import { useAiStatusTag } from './useAiStatusTag';

type Props = {
  spaceId?: string;
};

/** Read-only AI state of the space; the switch lives in the space settings. */
export default function AiStatusTag(props: Props) {
  const hook = useAiStatusTag(props);

  if (!hook.isVisible) {
    return null;
  }

  return (
    <Tooltip title={hook.tooltip} describeChild>
      <span>
        <Tag
          color={hook.isAiEnabled ? 'done' : 'default'}
          variantIcon="state"
          label={hook.label}
        />
      </span>
    </Tooltip>
  );
}
